/**
 * #15: utilitário para "colar do Excel".
 *
 * Converte texto colado da área de transferência (TSV — colunas separadas por
 * TAB, linhas por quebra de linha, como o Excel copia) em um arquivo .xlsx
 * em memória, para reaproveitar EXATAMENTE o mesmo pipeline de importação por
 * arquivo (mesma validação do backend).
 */
import * as XLSX from 'xlsx';

/** Parseia o texto colado em uma matriz de linhas/colunas.
 *  Usa TAB como separador (padrão do Excel). Linhas vazias são descartadas. */
export function parseTsv(text: string): string[][] {
  return (text || '')
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .filter((line) => line.trim() !== '')
    .map((line) => line.split('\t').map((c) => c.trim()));
}

/** Converte o texto colado (TSV) em um File .xlsx pronto para upload.
 *  Retorna null se não houver linhas válidas. */
export function tsvToXlsxFile(text: string, filename = 'colado.xlsx'): File | null {
  const rows = parseTsv(text);
  if (rows.length === 0) return null;

  const ws = XLSX.utils.aoa_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Dados');
  const buf = XLSX.write(wb, { type: 'array', bookType: 'xlsx' });
  return new File([buf], filename, {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
}
